// Internationalization (PT/ES) - simple key-based translation
import { createContext, useContext, useEffect, useState } from 'react';

const translations = {
  es: {
    app_name: 'Gestor Restaurante',
    // Nav
    nav_dashboard: 'Panel',
    nav_pos: 'POS / Mesas',
    nav_floor_plan: 'Plano del local',
    nav_reservations: 'Reservas',
    nav_kds: 'Cocina (KDS)',
    nav_menu: 'Menú',
    nav_recipes: 'Recetas (Escandallos)',
    nav_inventory: 'Inventario',
    nav_suppliers: 'Proveedores',
    nav_expenses: 'Gastos',
    nav_income: 'Ingresos',
    nav_invoices: 'Facturas',
    nav_reports: 'Informes',
    nav_pgc: 'PGC PYMES',
    nav_locations: 'Locales',
    nav_settings: 'Configuración',
    section_operation: 'Operación',
    section_product: 'Producto',
    section_finance: 'Finanzas',
    section_system: 'Sistema',
    // Common
    save: 'Guardar',
    cancel: 'Cancelar',
    create: 'Crear',
    edit: 'Editar',
    delete: 'Eliminar',
    add: 'Añadir',
    search: 'Buscar',
    actions: 'Acciones',
    name: 'Nombre',
    description: 'Descripción',
    category: 'Categoría',
    price: 'Precio',
    quantity: 'Cantidad',
    total: 'Total',
    base: 'Base',
    iva: 'IVA',
    date: 'Fecha',
    status: 'Estado',
    notes: 'Notas',
    confirm: 'Confirmar',
    close: 'Cerrar',
    open: 'Abrir',
    yes: 'Sí',
    no: 'No',
    loading: 'Cargando...',
    no_data: 'Sin datos',
    // Dashboard
    sales_today: 'Ventas hoy',
    sales_week: 'Ventas semana',
    sales_month: 'Ventas mes',
    expenses_month: 'Gastos mes',
    profit_month: 'Beneficio mes',
    food_cost: 'Food cost',
    open_orders: 'Pedidos abiertos',
    occupied_tables: 'Mesas ocupadas',
    top_dishes: 'Platos más vendidos',
    low_stock: 'Stock bajo',
    sales_evolution: 'Evolución de ventas (14 días)',
    ai_insights: 'Insights IA',
    refresh: 'Actualizar',
    // POS
    tables: 'Mesas',
    new_order: 'Nuevo pedido',
    table_status_libre: 'Libre',
    table_status_ocupada: 'Ocupada',
    table_status_cuenta_solicitada: 'Pide cuenta',
    table_status_reservada: 'Reservada',
    open_table: 'Abrir mesa',
    add_item: 'Añadir',
    send_to_kitchen: 'Enviar a cocina',
    print_kitchen_pdf: 'Imprimir comanda PDF',
    close_order: 'Cerrar pedido',
    payment_method: 'Método de pago',
    cash: 'Efectivo',
    card: 'Tarjeta',
    bizum: 'Bizum',
    transfer: 'Transferencia',
    other: 'Otro',
    diners: 'Comensales',
    waiter: 'Camarero',
    no_tables: 'No hay mesas. Crea la primera.',
    create_table: 'Crear mesa',
    table_number: 'Nº mesa',
    capacity: 'Capacidad',
    zone: 'Zona',
    // KDS
    kds_status_new: 'Nuevo',
    kds_status_preparing: 'Preparando',
    kds_status_ready: 'Listo',
    kds_status_served: 'Servido',
    elapsed: 'Transcurrido',
    mark_preparing: 'Empezar',
    mark_ready: 'Listo',
    mark_served: 'Servido',
    no_orders_kitchen: 'Sin pedidos en cocina',
    fullscreen: 'Pantalla completa',
    // Menu
    menu_categories: 'Categorías del menú',
    menu_items: 'Platos del menú',
    new_category: 'Nueva categoría',
    new_dish: 'Nuevo plato',
    iva_pct: 'IVA %',
    active: 'Activo',
    allergens: 'Alérgenos',
    link_recipe: 'Receta vinculada',
    // Recipes
    recipe_name: 'Nombre receta',
    portions: 'Raciones',
    target_food_cost: 'Food cost objetivo (%)',
    ingredients: 'Ingredientes',
    add_ingredient: 'Añadir ingrediente',
    waste_pct: 'Merma %',
    unit_cost: 'Coste unitario',
    final_cost: 'Coste final',
    total_cost: 'Coste total',
    cost_per_portion: 'Coste por ración',
    suggested_price: 'PVP sugerido',
    ai_suggest_price: 'Sugerir precio IA',
    // Inventory
    products: 'Productos',
    stock: 'Stock',
    min_stock: 'Stock mínimo',
    unit: 'Unidad',
    movement_entrada: 'Entrada',
    movement_salida: 'Salida',
    movement_merma: 'Merma',
    movement_ajuste: 'Ajuste',
    new_movement: 'Nuevo movimiento',
    movement_history: 'Historial movimientos',
    suppliers: 'Proveedores',
    new_supplier: 'Nuevo proveedor',
    nif: 'NIF',
    email: 'Email',
    phone: 'Teléfono',
    address: 'Dirección',
    // Expenses / Income
    new_expense: 'Nuevo gasto',
    new_income: 'Nuevo ingreso',
    pgc_account: 'Cuenta PGC',
    ai_suggest_pgc: 'Sugerir IA',
    ai_confidence: 'Confianza',
    payment_pending: 'Pendiente',
    payment_paid: 'Pagado',
    invoice_number: 'Nº factura',
    supplier_name: 'Proveedor',
    expense_total: 'Importe total',
    // Invoices
    invoice_type: 'Tipo',
    invoice_type_ticket: 'Ticket',
    invoice_type_simplificada: 'Factura simplificada',
    invoice_type_completa: 'Factura completa',
    customer_name: 'Cliente',
    customer_nif: 'NIF cliente',
    customer_address: 'Dirección cliente',
    download_pdf: 'Descargar PDF',
    new_invoice: 'Nueva factura',
    iva_breakdown: 'Desglose IVA',
    // Reports
    report_diario: 'Libro Diario',
    report_mayor: 'Libro Mayor',
    report_profitability: 'Rentabilidad por plato',
    debit: 'Debe',
    credit: 'Haber',
    // Settings / AI
    settings_restaurant: 'Datos del restaurante',
    settings_taxes: 'Impuestos / IVA',
    settings_language: 'Idioma',
    settings_ai: 'Inteligencia Artificial',
    settings_invoicing: 'Facturación',
    ai_provider: 'Proveedor IA',
    api_key_label: 'Clave API',
    ai_test: 'Probar conexión',
    ai_test_ok: 'Conexión OK',
    ai_test_fail: 'Error de conexión',
    ai_default_model: 'Modelo',
    settings_saved: 'Configuración guardada',
    invoice_prefix: 'Prefijo factura',
    invoice_serie: 'Serie factura',
    iva_default: 'IVA por defecto (%)',
    food_cost_default: 'Food cost objetivo (%)',
    restaurant_name: 'Nombre del restaurante',
    // AI Assistant
    ai_assistant: 'Asistente IA',
    ai_ask: 'Pregunta a la IA...',
    ai_send: 'Enviar',
    ai_quick_today: 'Resumen del día',
    ai_quick_low_stock: 'Stock bajo',
    ai_quick_classify: 'Clasificar gasto',
    ai_quick_invoice: 'Generar factura',
    ai_loading: 'Pensando...',
    // PGC
    pgc_chart: 'Cuadro de cuentas PGC PYMES',
    pgc_group: 'Grupo',
    pgc_code: 'Código',
    pgc_name: 'Nombre',
    pgc_type: 'Tipo',
    // Misc
    today: 'Hoy',
    week: 'Semana',
    month: 'Mes',
    year: 'Año',
    welcome: 'Bienvenido a tu Gestor de Restaurante',
    welcome_subtitle: 'Operación, finanzas, IA. Todo en un solo lugar.',
  },
  pt: {
    app_name: 'Gestor Restaurante',
    nav_dashboard: 'Painel',
    nav_pos: 'POS / Mesas',
    nav_floor_plan: 'Planta do salão',
    nav_reservations: 'Reservas',
    nav_kds: 'Cozinha (KDS)',
    nav_menu: 'Cardápio',
    nav_recipes: 'Receitas (Escandallos)',
    nav_inventory: 'Estoque',
    nav_suppliers: 'Fornecedores',
    nav_expenses: 'Despesas',
    nav_income: 'Receitas',
    nav_invoices: 'Faturas',
    nav_reports: 'Relatórios',
    nav_pgc: 'PGC PYMES',
    nav_locations: 'Locais',
    nav_settings: 'Configurações',
    section_operation: 'Operação',
    section_product: 'Produto',
    section_finance: 'Finanças',
    section_system: 'Sistema',
    save: 'Salvar',
    cancel: 'Cancelar',
    create: 'Criar',
    edit: 'Editar',
    delete: 'Excluir',
    add: 'Adicionar',
    search: 'Buscar',
    actions: 'Ações',
    name: 'Nome',
    description: 'Descrição',
    category: 'Categoria',
    price: 'Preço',
    quantity: 'Quantidade',
    total: 'Total',
    base: 'Base',
    iva: 'IVA',
    date: 'Data',
    status: 'Status',
    notes: 'Notas',
    confirm: 'Confirmar',
    close: 'Fechar',
    open: 'Abrir',
    yes: 'Sim',
    no: 'Não',
    loading: 'Carregando...',
    no_data: 'Sem dados',
    sales_today: 'Vendas hoje',
    sales_week: 'Vendas semana',
    sales_month: 'Vendas mês',
    expenses_month: 'Despesas mês',
    profit_month: 'Lucro mês',
    food_cost: 'Food cost',
    open_orders: 'Pedidos abertos',
    occupied_tables: 'Mesas ocupadas',
    top_dishes: 'Pratos mais vendidos',
    low_stock: 'Estoque baixo',
    sales_evolution: 'Evolução de vendas (14 dias)',
    ai_insights: 'Insights IA',
    refresh: 'Atualizar',
    tables: 'Mesas',
    new_order: 'Novo pedido',
    table_status_libre: 'Livre',
    table_status_ocupada: 'Ocupada',
    table_status_cuenta_solicitada: 'Pede conta',
    table_status_reservada: 'Reservada',
    open_table: 'Abrir mesa',
    add_item: 'Adicionar',
    send_to_kitchen: 'Enviar à cozinha',
    print_kitchen_pdf: 'Imprimir comanda PDF',
    close_order: 'Fechar pedido',
    payment_method: 'Forma de pagamento',
    cash: 'Dinheiro',
    card: 'Cartão',
    bizum: 'Bizum',
    transfer: 'Transferência',
    other: 'Outro',
    diners: 'Comensais',
    waiter: 'Garçom',
    no_tables: 'Sem mesas. Cria a primeira.',
    create_table: 'Criar mesa',
    table_number: 'Nº mesa',
    capacity: 'Capacidade',
    zone: 'Zona',
    kds_status_new: 'Novo',
    kds_status_preparing: 'Preparando',
    kds_status_ready: 'Pronto',
    kds_status_served: 'Servido',
    elapsed: 'Tempo',
    mark_preparing: 'Iniciar',
    mark_ready: 'Pronto',
    mark_served: 'Servido',
    no_orders_kitchen: 'Sem pedidos na cozinha',
    fullscreen: 'Tela cheia',
    menu_categories: 'Categorias do cardápio',
    menu_items: 'Pratos do cardápio',
    new_category: 'Nova categoria',
    new_dish: 'Novo prato',
    iva_pct: 'IVA %',
    active: 'Ativo',
    allergens: 'Alérgenos',
    link_recipe: 'Receita vinculada',
    recipe_name: 'Nome receita',
    portions: 'Porções',
    target_food_cost: 'Food cost objetivo (%)',
    ingredients: 'Ingredientes',
    add_ingredient: 'Adicionar ingrediente',
    waste_pct: 'Perda %',
    unit_cost: 'Custo unitário',
    final_cost: 'Custo final',
    total_cost: 'Custo total',
    cost_per_portion: 'Custo por porção',
    suggested_price: 'PVP sugerido',
    ai_suggest_price: 'Sugerir preço IA',
    products: 'Produtos',
    stock: 'Estoque',
    min_stock: 'Estoque mínimo',
    unit: 'Unidade',
    movement_entrada: 'Entrada',
    movement_salida: 'Saída',
    movement_merma: 'Perda',
    movement_ajuste: 'Ajuste',
    new_movement: 'Novo movimento',
    movement_history: 'Histórico movimentos',
    suppliers: 'Fornecedores',
    new_supplier: 'Novo fornecedor',
    nif: 'NIF',
    email: 'Email',
    phone: 'Telefone',
    address: 'Endereço',
    new_expense: 'Nova despesa',
    new_income: 'Nova receita',
    pgc_account: 'Conta PGC',
    ai_suggest_pgc: 'Sugerir IA',
    ai_confidence: 'Confiança',
    payment_pending: 'Pendente',
    payment_paid: 'Pago',
    invoice_number: 'Nº fatura',
    supplier_name: 'Fornecedor',
    expense_total: 'Total',
    invoice_type: 'Tipo',
    invoice_type_ticket: 'Ticket',
    invoice_type_simplificada: 'Fatura simplificada',
    invoice_type_completa: 'Fatura completa',
    customer_name: 'Cliente',
    customer_nif: 'NIF cliente',
    customer_address: 'Endereço cliente',
    download_pdf: 'Baixar PDF',
    new_invoice: 'Nova fatura',
    iva_breakdown: 'Detalhe IVA',
    report_diario: 'Livro Diário',
    report_mayor: 'Livro Razão',
    report_profitability: 'Rentabilidade por prato',
    debit: 'Débito',
    credit: 'Crédito',
    settings_restaurant: 'Dados do restaurante',
    settings_taxes: 'Impostos / IVA',
    settings_language: 'Idioma',
    settings_ai: 'Inteligência Artificial',
    settings_invoicing: 'Faturamento',
    ai_provider: 'Provedor IA',
    api_key_label: 'Chave API',
    ai_test: 'Testar conexão',
    ai_test_ok: 'Conexão OK',
    ai_test_fail: 'Erro de conexão',
    ai_default_model: 'Modelo',
    settings_saved: 'Configuração salva',
    invoice_prefix: 'Prefixo fatura',
    invoice_serie: 'Série fatura',
    iva_default: 'IVA padrão (%)',
    food_cost_default: 'Food cost objetivo (%)',
    restaurant_name: 'Nome do restaurante',
    ai_assistant: 'Assistente IA',
    ai_ask: 'Pergunte à IA...',
    ai_send: 'Enviar',
    ai_quick_today: 'Resumo do dia',
    ai_quick_low_stock: 'Estoque baixo',
    ai_quick_classify: 'Classificar despesa',
    ai_quick_invoice: 'Gerar fatura',
    ai_loading: 'Pensando...',
    pgc_chart: 'Quadro de contas PGC PYMES',
    pgc_group: 'Grupo',
    pgc_code: 'Código',
    pgc_name: 'Nome',
    pgc_type: 'Tipo',
    today: 'Hoje',
    week: 'Semana',
    month: 'Mês',
    year: 'Ano',
    welcome: 'Bem-vindo ao seu Gestor de Restaurante',
    welcome_subtitle: 'Operação, finanças, IA. Tudo em um só lugar.',
  },
};

const I18nContext = createContext({ lang: 'es', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('app_lang') || 'es');
  useEffect(() => {
    localStorage.setItem('app_lang', lang);
    document.documentElement.lang = lang === 'pt' ? 'pt-BR' : 'es-ES';
  }, [lang]);
  const t = (key) => translations[lang]?.[key] ?? translations.es[key] ?? key;
  const setLang = (l) => setLangState(l);
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function formatCurrency(value, lang = 'es') {
  const locale = lang === 'pt' ? 'pt-BR' : 'es-ES';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(value || 0);
}

export function formatDate(value, lang = 'es') {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const locale = lang === 'pt' ? 'pt-BR' : 'es-ES';
  return d.toLocaleDateString(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function formatDateTime(value, lang = 'es') {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const locale = lang === 'pt' ? 'pt-BR' : 'es-ES';
  return d.toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' });
}
